import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import PropTypes from 'prop-types';
import React from 'react';
import locale from '../locale/Localization';

/**

 * Notary contract field.
 * @param {P} props the props.
 * @return {*} the rendered string.
 */
export default function ContractRadio(props) {
  return (
    <FormControl component='fieldset'>
      <FormLabel component='legend'>{locale.contract}</FormLabel>
      <RadioGroup
        aria-label='position'
        name='contract'
        value={props.contract}
        onChange={(event) => {
          props.handleFieldChange(event);
        }}
        row
      >
        <FormControlLabel
          disabled={props.disabled}
          value='contractAmongLiving'
          control={<Radio color='primary' />}
          label={locale.contractAmongLiving}
          labelPlacement='left'
        />
        <FormControlLabel
          disabled={props.disabled}
          value='contractByDead'
          control={<Radio color='primary' />}
          label={locale.contractByDead}
          labelPlacement='left'
        />
        <FormControlLabel
          disabled={props.disabled}
          value='contractByDead+contractAmongLiving'
          control={<Radio color='primary' />}
          label={locale.contractAmongLiving + ' / ' + locale.contractByDead}
          labelPlacement='left'
        />
        <FormControlLabel
          disabled={props.disabled}
          value='authentication'
          control={<Radio color='primary' />}
          label={locale.authentication}
          labelPlacement='left'
        />
      </RadioGroup>
    </FormControl>
  );
}

ContractRadio.propTypes = {
  handleFieldChange: PropTypes.func,
  contract: PropTypes.string,
  disabled: PropTypes.bool
};
